import { render, staticRenderFns } from "./RestaurantDetailsSection.vue?vue&type=template&id=18aa3f02&scoped=true&"
import script from "./RestaurantDetailsSection.vue?vue&type=script&lang=js&"
export * from "./RestaurantDetailsSection.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantDetailsSection.vue?vue&type=style&index=0&id=18aa3f02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aa3f02",
  null
  
)

export default component.exports